var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6106 6.4458V16.9184H63.2402",
    stroke: "#ED744E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9082 76.1782V65.7056H20.2786",
    stroke: "#719C4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5945 22.7944C80.7219 28.4952 82.4997 35.0418 82.4997 42.0018C82.4997 64.0937 64.5915 82.0018 42.4997 82.0018C29.3811 82.0018 17.7367 75.6863 10.4434 65.9292",
    stroke: "#719C4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73556 59.9353C4.02444 54.5412 2.5 48.4494 2.5 42.002C2.5 19.9086 20.4081 2.00195 42.5 2.00195C54.9281 2.00195 66.0319 7.6701 73.3696 16.562",
    stroke: "#ED744E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 68.001C56.8594 68.001 68.5 56.3604 68.5 42.001C68.5 27.6416 56.8594 16.001 42.5 16.001C28.1406 16.001 16.5 27.6416 16.5 42.001C16.5 56.3604 28.1406 68.001 42.5 68.001Z",
    fill: "#F9E9E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0547 46.5054C38.0547 48.9276 40.0443 50.8906 42.4991 50.8906C44.9539 50.8906 46.9436 48.9276 46.9436 46.5054C46.9436 43.0595 42.4991 41.8061 42.4991 41.8061C42.4991 41.8061 38.0547 40.5528 38.0547 37.1069C38.0547 34.6847 40.0443 32.7202 42.4991 32.7202C44.9539 32.7202 46.9436 34.6847 46.9436 37.1069",
    stroke: "#ED744E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4986 30.1494V32.7198",
    stroke: "#ED744E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4986 53.8531V50.8901",
    stroke: "#ED744E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBack);
export default __webpack_public_path__ + "static/media/money_back.b9b26f25a9abd607e18c20dc6e7998d3.svg";
export { ForwardRef as ReactComponent };